"use strict";
'use client';
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var react_1 = __importStar(require("react"));
var react_final_form_1 = require("react-final-form");
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var useInitialValues_1 = require("./useInitialValues");
var useValidateSchema_1 = require("./useValidateSchema");
var useGiftcodeBonus_1 = require("../../common/LoginGiftcodeBonus/useGiftcodeBonus");
var navigation_1 = require("next/navigation");
var LogIn = function (_a) {
    var _b = _a.withLabels, withLabels = _b === void 0 ? true : _b, LoginBanner = _a.LoginBanner, authInputMode = _a.authInputMode, isUserWasAuth = _a.isUserWasAuth;
    var t = (0, next_intl_1.useTranslations)('translation');
    var tErr = (0, next_intl_1.useTranslations)('errors');
    var validateSchema = (0, useValidateSchema_1.useValidateSchema)();
    var initialValues = (0, useInitialValues_1.useInitialValues)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var forgotPasswordUrl = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.FORGOT_PASS, true);
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var isAuth = (0, swr_hooks_1.useIsAuthorized)();
    var backUrl = searchParams.get('back');
    var closeWindow = (0, apps_shared_1.useCloseModal)();
    var _c = (0, useGiftcodeBonus_1.useGiftcodeBonus)(), giftcodeBonus = _c.bonus, promoId = _c.promoId;
    var openLogInBonusCongrats = (0, apps_shared_1.useOpenLogInBonusCongrats)();
    var activatePromocode = (0, swr_hooks_1.useActivatePromocode)({}).activatePromocode;
    var signUpUrl = (0, apps_shared_1.useModalLink)(apps_shared_1.POPUP_CONSTANTS.SIGN_UP_MODAL, true);
    var _d = (0, swr_hooks_1.useLogin)({
        successAction: function () {
            if (giftcodeBonus && promoId) {
                openLogInBonusCongrats();
                activatePromocode({ basePromoId: promoId });
            }
            else if (backUrl)
                router.push(backUrl);
            else
                closeWindow();
        },
    }), login = _d.login, isSubmitting = _d.isSubmitting, error = _d.error;
    var router = (0, navigation_1.useRouter)();
    (0, react_1.useEffect)(function () {
        if (isUserWasAuth && isAuth) {
            if (backUrl)
                return router.replace(backUrl);
            router.replace('/');
        }
    }, [isUserWasAuth, router, isAuth, backUrl]);
    var onSubmitHandler = (0, react_1.useCallback)(function (values) {
        login({ login: values.email, password: values.password });
    }, [login]);
    return (react_1.default.createElement(ui_components_1.Modal, { width: "320px", saveSize: true },
        Object.keys(breakpoints).length > 0 && breakpoints.mobile ? (react_1.default.createElement(react_1.default.Fragment, null, LoginBanner ? (react_1.default.createElement(LoginBanner, null)) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("img", { className: styles_module_scss_1.default.loginBanner, src: "/img/login_banner_mobile.jpg", alt: "welcome login" }))))) : null,
        react_1.default.createElement(ui_components_1.ModalTitle, null, t('login')),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.content },
            react_1.default.createElement(react_final_form_1.Form, { initialValues: initialValues, onSubmit: onSubmitHandler, validate: (0, apps_shared_1.formValidator)(validateSchema), render: function (_a) {
                    var handleSubmit = _a.handleSubmit, submitting = _a.submitting;
                    return (react_1.default.createElement("form", { onSubmit: handleSubmit },
                        react_1.default.createElement("div", null,
                            react_1.default.createElement(react_final_form_1.Field, { name: "email", render: function (_a) {
                                    var input = _a.input, meta = _a.meta;
                                    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                        react_1.default.createElement(ui_components_1.InputText, __assign({}, input, { mode: authInputMode, placeholder: "user@gmail.com", labelText: withLabels ? t('email') : undefined, helperButton: meta.error && meta.touched && { type: 'error' } })),
                                        meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                                } }),
                            react_1.default.createElement(react_final_form_1.Field, { name: "password", render: function (_a) {
                                    var input = _a.input, meta = _a.meta;
                                    return (react_1.default.createElement("div", { className: styles_module_scss_1.default.fieldWrapper },
                                        react_1.default.createElement(ui_components_1.InputPassword, __assign({}, input, { mode: authInputMode, placeholder: t('enterPassword'), labelText: withLabels ? t('password') : undefined, hasError: meta.error && meta.touched })),
                                        meta.error && meta.touched && (react_1.default.createElement(ui_components_1.ErrorText, null, meta.error))));
                                } }),
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.mainErrorWrapper }, error && (react_1.default.createElement(ui_components_1.ErrorText, { style: {
                                    width: '100%',
                                    textAlign: 'center',
                                } },
                                react_1.default.createElement("span", { dangerouslySetInnerHTML: {
                                        __html: tErr.raw(error),
                                    } }))))),
                        react_1.default.createElement("div", null,
                            react_1.default.createElement("br", null),
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.buttonWrapper },
                                react_1.default.createElement(ui_components_1.FixedButton, { type: "submit", loading: isSubmitting || submitting, text: "upper" }, t('login'))),
                            react_1.default.createElement("div", { className: styles_module_scss_1.default.centerLinkWrapper },
                                react_1.default.createElement(ui_components_1.TextLink, { href: forgotPasswordUrl }, t('ifForgotPassword')),
                                react_1.default.createElement(ui_components_1.TextLink, { href: signUpUrl }, t('signup'))))));
                } }))));
};
exports.default = LogIn;
